import React from "react"
import PostListItem from "./postListItem"
import PostListEvent from "./postListEvent"

import styles from "./postList.module.scss"

const PostList = (props) => {
  return (
    <section className={styles.postMain}>
      <ul className={styles.postList} data-theme={props.theme}>
        {props.items && props.items.map(({node: item}) => <PostListItem label={props.label} {...item} key={item.id} type={props.type} alt={props.alt} />)}
        {props.events && props.events.map(event => <PostListEvent key={event._id} {...event} />)}
      </ul>
    </section>
  )
}

export default PostList
